// Client service for API calls
import { ClientData } from '../types';
import { fetchWithErrorHandling, guestPrefix } from './apiUtils';

export class ClientService {
  static async getClientData(): Promise<ClientData> {
    try {
      // Try API first - use guest or authenticated endpoint based on auth state
      try {
        return await fetchWithErrorHandling<ClientData>(
          `/api/v2${guestPrefix()}/client`,
          undefined
        );
      } catch (apiError) {
        console.warn('API not available, falling back to local data:', apiError);

        // Fall back to local JSON file
        try {
          const { default: localClientData } = await import('../data/clientData.json');
          return localClientData as ClientData;
        } catch (localError) {
          console.error('Failed to load local client data:', localError);
          throw new Error('Unable to load client data from both API and local data.');
        }
      }
    } catch (error) {
      console.error('Failed to fetch client data:', error);

      // Return minimal fallback data as last resort
      return {
        logoUrl: '',
        helpInfo: {},
        clientMessage: undefined
      };
    }
  }
}
